import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'

interface FooterProps {
    /* On the flythrough the page never scrolls, so the footer pins to the
     * bottom of the viewport as an overlay instead of sitting in flow. */
    overlay?: boolean
}

/* Deliberately thin — one hairline and a line of mono micro-labels, the same
 * vocabulary as the nav and the card backs. */
export const Footer: FC<FooterProps> = ({ overlay = false }): ReactNode => {
    return (
        <footer
            className={cn(
                'border-t border-white/10 px-5 py-4 sm:px-9',
                overlay ? 'fixed inset-x-0 bottom-0 z-50 bg-stage/40 backdrop-blur-md' : 'bg-stage'
            )}
        >
            <div className='flex items-center justify-between gap-4 font-mono text-[0.62rem] uppercase tracking-[0.14em] text-white/40 sm:text-[0.68rem]'>
                <span suppressHydrationWarning>
                    © {new Date().getFullYear()} Fathom
                </span>

                <span className='hidden text-white/25 md:inline'>
                    Twenty-one frames in endless rotation
                </span>

                <Link
                    href='/contact'
                    className='transition-colors duration-500 hover:text-white/70'
                >
                    Enquiries
                </Link>
            </div>
        </footer>
    )
}
